import React from 'react'

import { selectTitle } from '../../dashboard'
import { ExamInterface } from '../ExamInterface/ExamInterface'
import { selectTasks } from '../selector'

import style from './ExamBox.module.css'

import { useAppSelector } from 'common/hooks'

type PropsType = {
  testId: string
}

export const ExamBox = ({ testId }: PropsType) => {
  const tasks = useAppSelector(selectTasks)
  const title = useAppSelector(state => selectTitle(state, testId))

  return (
    <>
      {tasks.length === 0 ? (
        <p>Тест в разработке...</p>
      ) : (
        <>
          <h1 className={style.title}>Тест по направлению {title}</h1>
          <ExamInterface tasks={tasks} testId={testId} />
        </>
      )}
    </>
  )
}
